<template>
  <div class="question-view-dialog ">
    <div class="quest">
      <div class="title">
        <vue-mathjax :formula="form.title" :safe="false"/>
      </div>
      <div class="btn-list">
        <div :class="['single', its.check && 'check']" :data-id="its.id" v-for="(its, idx) in trueFlase" :key="idx" @click="checkSingle(idx, its.id)">
          <span :class="its.class"></span>
          {{ its.text }}
        </div>
      </div>
    </div>
    <div class="quest-img" v-if="form.img_url || form.imgUrl" @click="$emit('urlToParent', form.img_url || form.imgUrl)">
      <img :src="form.img_url || form.imgUrl" :style="imgStyle" alt="">
    </div>
  </div>
</template>

<script>
export default {
  props: ['form', 'mode'],
  data() {
    return {
      image: '',
      topic: '',
      trueFlase: [],

      imgStyle: null,
      answer_results: {
        id: null,
        student_choices: []
      },
      bodyWidth: 1960,
      recordQuestion: null
    }
  },
  methods: {
    getBodyWidth() {
      let body = document.querySelector('.dialog-preview .body')
      // console.log(body)

      return body.offsetWidth;
    },
    checkSingle(idx, choice_id) {
      this.trueFlase.filter((its, index) => index == idx ? its.check = true : its.check = false)
      this.$emit('permissions', true)
      this.recordQuestion = Number(choice_id)
      this.answer_results.student_choices = [{choice_id: Number(choice_id), value: ''}]
    },
    initData() {
      this.answer_results = {
        id: null,
        student_choices: []
      }
      this.recordQuestion = null
      this.trueFlase = []
      
      this.trueFlase = this.form.choices.map(its => 
        ({id: its.id, text: its.value == '0' ? '正確' : '錯誤', 
          check: false, class: its.value == '0' ? 'true-icon' : 'false-icon'}))
      if(this.mode == 'viewAnswer') setTimeout(() => this.showTrueFalse(), 500)

      this.$nextTick(() => {
        // 还原答案
        let answers = this.form.answers,
          singles = document.querySelectorAll('.dialog-preview .single')
        for(let i = 0; i < answers.length; i++) {
          let idx = answers[i].value
          singles[idx].classList.add('determine-success-br')
        }
      })
    }
  },
  watch: {
    'form.id': {
      handler() {
        this.initData()
      },
      deep: true
    },
  },
  created() {
    this.initData()
  },
  mounted() {
    this.bodyWidth = this.getBodyWidth()
    
    window.onresize = () => {
      this.bodyWidth = this.getBodyWidth()
      // console.log(this.bodyWidth)
    } 
  }
}
</script>

<style scoped lang="scss">
.question-view-dialog {
  width: 100%;
  height: 100%;
  padding: 20px ;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 10px;
  .quest {
    // width: calc(55% - 10px);
    flex: 1;
    height: 100%;
    .title {
      font-size: 18px;
      color: #333;
    }
    .btn-list {
      width: calc(55% - 10px);
      margin-top: 20px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .single {
        width: calc(50% - 10px);
        padding: 10px;
        box-sizing: border-box;
        border-radius: 10px;
        border: 2px solid #fcd2ab;
        background-color: #fcd2ab;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 10px;
        cursor: pointer;
        font-weight: 700;
        font-size: 18px;
        color: #333;
        .true-icon {
          position: relative;
          width: 28px;
          height: 28px;
          
          &:after {
            position: absolute;
            top: -5px;
            bottom: 0;
            left: -20px;
            right: 0;
            margin: auto;
            content: '';
            width: 20px;
            height: 11px;
            border: 4px solid #f6a053;
            border-top: none;
            border-right: none;
            border-radius: 2px;
            transform: rotateZ(-45deg);
          }
        }

        .false-icon {
          position: relative;
          width: 28px;
          height: 28px;
          
          &:after ,&:before {
            content: '';
            position: absolute;
            top: 0;
            left: -20px;
            right: 0;
            bottom: 0;
            margin: auto;
            background-color: #f6a053;
            width: 20px;
            height: 4px;
            transform-origin: center center;
            transform: rotateZ(-45deg);
            border-radius: 20px;
          }

          &:before {
            transform: rotateZ(45deg);
          }
        }

        &:hover {
          opacity: .8;
        }
      }
      .check {
        background-color: #f8ae64;
        border-color: #d17224;
        .true-icon {
          &:after {
            border-color: #d17224;
          }
        } 
        .false-icon {
          &:after, &:before {
            background-color: #d17224;
          }
        }
      }
    }
  }
  .quest-img {
    max-width: 40%;
    flex: 1;
    max-height: 500px;
    aspect-ratio: 833/500;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    
    img {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      height: auto;
      border-radius: 5px;
    }
  }
}
</style>